// extracted by mini-css-extract-plugin
var _1 = "EntityTabPostsSearch-modulesearch__je25x";
export { _1 as "search" }
